<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch005_1"></a><a id="page_vii"></a>CONTENTS</h2>
<p class="toc-front"><a href="#/xhtml/ch006#ch006_1"><em>Foreword</em></a> <em>by Jo Ann Jenkins</em></p>
<p class="toc-chap"><a href="#/xhtml/ch007#ch007_1">PREFACE</a></p>
<p class="toc-chap1"><a href="#/xhtml/ch007#ch007_1"><strong>Reimagined Lives</strong></a></p>
<p class="toc-chap"><a href="#/xhtml/ch008#ch008_1">INTRODUCTION</a></p>
<p class="toc-chap1"><a href="#/xhtml/ch008#ch008_1"><strong>The End of Work As We Know It</strong></a></p>
<p class="toc-chap"><span href="#/xhtml/ch009#ch009_1" title="Link target outside of Sample">CHAPTER 1</span></p>
<p class="toc-chap1"><span href="#/xhtml/ch009#ch009_1" title="Link target outside of Sample"><strong>Reimagining Work—What Do You Do?</strong></span></p>
<p class="toc-chap"><span href="#/xhtml/ch010#ch010_1" title="Link target outside of Sample">CHAPTER 2</span></p>
<p class="toc-chap1"><span href="#/xhtml/ch010#ch010_1" title="Link target outside of Sample"><strong>Reimagining Calling—Should You Quit Your Day Job?</strong></span></p>
<p class="toc-chap"><span href="#/xhtml/ch011#ch011_1" title="Link target outside of Sample">CHAPTER 3</span></p>
<p class="toc-chap1"><span href="#/xhtml/ch011#ch011_1" title="Link target outside of Sample"><strong>Reimagining Gifts—How Do You Do It?</strong></span></p>
<p class="toc-chap"><span href="#/xhtml/ch012#ch012_1" title="Link target outside of Sample">CHAPTER 4</span></p>
<p class="toc-chap1"><span href="#/xhtml/ch012#ch012_1" title="Link target outside of Sample"><strong>Reimagining Passions—Why Do You Do It?</strong></span></p>
<p class="toc-chap"><span href="#/xhtml/ch013#ch013_1" title="Link target outside of Sample">CHAPTER 5</span></p>
<p class="toc-chap1"><span href="#/xhtml/ch013#ch013_1" title="Link target outside of Sample"><strong>Reimagining Values—Where Do You Do It?</strong></span></p>
<p class="toc-chap"><span href="#/xhtml/ch014#ch014_1" title="Link target outside of Sample">CHAPTER 6</span></p>
<p class="toc-chap1b"><span href="#/xhtml/ch014#ch014_1" title="Link target outside of Sample"><strong>Reimagining Legacy—Have You Played Your Music?</strong></span></p>
<p class="toc-bm"><span href="#/xhtml/ch015#ch015_1" title="Link target outside of Sample"><em>Resources</em></span></p>
<p class="toc-bm"><span href="#/xhtml/ch016#ch016_1" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="toc-bm"><span href="#/xhtml/ch018#ch018_1" title="Link target outside of Sample"><em>About the Authors</em></span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?6039e1be